import React, { forwardRef, Ref, HTMLAttributes } from 'react';
import { cx } from '@emotion/css';
import * as styles from './styles';

export type Props = HTMLAttributes<HTMLUListElement> & {
  innerRef: Ref<HTMLUListElement>;
}

const NavList: React.FC<Props> = ({ className, innerRef, ...rest }) => (
  <ul className={cx(className, styles.main)} ref={innerRef} {...rest} />
)

export default forwardRef<HTMLUListElement, Omit<Props, 'innerRef'>>((props, ref) => {
  return <NavList {...props} innerRef={ref} />;
});
